/**
 * Global language store for SSR support
 * This allows the t() function to access the current language
 * without changing its signature
 */

// Define available languages locally to avoid circular dependency
export const availableLanguages = ['en', 'fr', 'de', 'it', 'es', 'ru', 'id', 'ar', 'th', 'vi', 'tr', 'nl', 'pl', 'ko', 'hi'] as const;
export type AvailableLanguage = (typeof availableLanguages)[number];

class LanguageStore {
    private language: AvailableLanguage = 'en';
    
    setLanguage(lang: AvailableLanguage) {
        this.language = lang;
    }
    
    getLanguage(): AvailableLanguage {
        return this.language;
    }
}

// Create a singleton instance
export const languageStore = new LanguageStore();